<script lang="ts">
  export let position: 'top' | 'middle' | 'bottom' = 'top';
  
  const adClientId = 'ca-pub-4290907022532058';
</script>

<div class="adsense-banner" data-position={position}>
  <!-- Google AdSense Banner Ad -->
  <ins class="adsbygoogle"
       style="display:block"
       data-ad-client={adClientId}
       data-ad-slot="responsive-banner"
       data-ad-format="auto"
       data-full-width-responsive="true"></ins>
  <script>
    (adsbygoogle = window.adsbygoogle || []).push({});
  </script>
</div>

<style>
  .adsense-banner {
    margin: 30px auto;
    text-align: center;
    max-width: 100%;
    overflow: hidden;
    padding: 20px;
    background: linear-gradient(135deg, rgba(46, 204, 113, 0.05) 0%, rgba(39, 174, 96, 0.05) 100%);
    border-radius: 15px;
    border: 2px solid rgba(46, 204, 113, 0.2);
  }
  
  @media (max-width: 768px) {
    .adsense-banner {
      padding: 15px;
      margin: 20px auto;
    }
  }
</style>
